export const SALES = 'Sales' as const;
export const LEASING = 'Leasing' as const;
export const FINANCE = 'Finance' as const;

export const VERTICAL_TYPES = [SALES, LEASING, FINANCE] as const;

export type VerticalType = (typeof VERTICAL_TYPES)[number];

export type NonFinanceVerticalType = Exclude<VerticalType, typeof FINANCE>;
